"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingShareAccounts;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function LoadingShareAccounts() {
  return (/*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '200px'
      }
    }, /*#__PURE__*/_react.default.createElement(_commonReact.ContentLoader, {
      height: 50,
      width: 200
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: "20",
      y: "18",
      width: "20",
      height: "20"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "60",
      y: "26",
      rx: "2",
      ry: "2",
      width: "160",
      height: "5"
    })))
  );
}